import { createRoute, redirect } from '@tanstack/react-router';

import { authPageLoadable } from 'pages/auth-page';
import { queryClient } from 'pages/root-page';

import { ensureAuthInfo } from 'entities/auth';

import { rootRoute } from '../root';

export const AuthRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/auth',
  beforeLoad: async () => {
    if (await ensureAuthInfo(queryClient)) {
      throw redirect({ to: '/installations' });
    }
  },
  component: authPageLoadable,
});
